export default {
	apiKey: "AIzaSyC7x2dsoNIHHXKo36KaY_GDsX_cYqbdzWM",
    authDomain: "ratefolio-192837465.firebaseapp.com",
    databaseURL: "https://ratefolio-192837465.firebaseio.com",
    projectId: "ratefolio-192837465",
    storageBucket: "ratefolio-192837465.appspot.com",
    messagingSenderId: "786913464176",
};
